import { render, staticRenderFns } from "./unit-alarms.vue?vue&type=template&id=a40f5df6&scoped=true&"
import script from "./unit-alarms.vue?vue&type=script&lang=js&"
export * from "./unit-alarms.vue?vue&type=script&lang=js&"
import style0 from "./unit-alarms.vue?vue&type=style&index=0&id=a40f5df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40f5df6",
  null
  
)

export default component.exports